import { themeLight } from './useReportTheme';

export interface ChartTheme {
  paper:  string;
  ink:    string;
  muted:  string;
  line:   string;
  accent: string;
  good:   string;
  warn:   string;
  bad:    string;
}

const DARK: ChartTheme = {
  paper:  '#0d2035',
  ink:    '#ffffff',
  muted:  'rgba(255,255,255,0.6)',
  line:   'rgba(255,255,255,0.1)',
  accent: '#c8f135',
  good:   '#22c55e',
  warn:   '#eab308',
  bad:    '#ef4444',
};

const LIGHT: ChartTheme = {
  paper:  '#ffffff',
  ink:    '#0f172a',
  muted:  '#475569',
  line:   '#e2e8f0',
  accent: '#6366f1',
  good:   '#22c55e',
  warn:   '#eab308',
  bad:    '#ef4444',
};

export function useChartTheme(): ChartTheme {
  const defaults = themeLight.value ? LIGHT : DARK;
  if (typeof window === 'undefined') return { ...defaults };
  const el = document.querySelector('.report-dashboard') ?? document.documentElement;
  const style = getComputedStyle(el);
  const get = (v: string, fallback: string): string =>
    style.getPropertyValue(v).trim() || fallback;
  return {
    paper:  get('--paper',  defaults.paper),
    ink:    get('--ink',    defaults.ink),
    muted:  get('--muted',  defaults.muted),
    line:   get('--line',   defaults.line),
    accent: get('--accent', defaults.accent),
    good:   get('--good',   defaults.good),
    warn:   get('--warn',   defaults.warn),
    bad:    get('--bad',    defaults.bad),
  };
}
